import { eAnimAssets, eModelAsset, eTextures, Game, rnd2 } from "../../Game";



export class Defender {
    static readonly SIZE = new pc.Vec3(0.5, 1.6, 0.5);

    private static _material: pc.StandardMaterial;

    private _entity: pc.Entity;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        let assets = Game.app.assets;

        this._entity = new pc.Entity();
        this._entity.addComponent(pc.eCompomentType.model, {
            type: pc.eModelType.asset,
            asset: assets.find(eModelAsset.character_1, pc.eAssetType.model),
            castShadows: true,
            receiveShadows: false,
            static: false,
        });

        if (!Defender._material) {
            let mat = Defender._material = (this._entity.model.meshInstances[0].material as pc.StandardMaterial).clone();

            mat.normalMap = undefined;
            mat.update();
        }

        this._entity.model.meshInstances[0].material = Defender._material;

        this._entity.addComponent(pc.eCompomentType.animation, {
            assets: [
                assets.find(eAnimAssets.defenderIdle, pc.eAssetType.animation),
            ],
            speed: 1,
            activate: false,
            loop: true
        });
        this._entity.enabled = false;
        Game.app.root.addChild(this._entity);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activate(x: number, z: number, rotation: number): void {
        this._entity.model.meshInstances[0].setParameter("texture_diffuseMap", Game.app.assets.find(eTextures.defender + rnd2.randomIntIn(0, 1), pc.eAssetType.texture).resource as pc.Texture);

        this._entity.setPosition(x, 0, z);
        this._entity.setEulerAngles(0, rotation, 0);
        this._entity.enabled = true;

        let anim = this._entity.animation;

        anim.play(eAnimAssets.defenderIdle, 0);
        anim.currentTime = rnd2.randomIn(0, anim.duration);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._entity.enabled = false;
    }
}